import angular from 'angular'
import moment from 'moment'
import 'moment/locale/es'
import app from '@app'
import deprecated from 'kendu/legacy'
import inicio from '@inicio'
import kendu from '@kendu'

moment.locale('es')

console.info('Application', {
  name: process.env.APP_NAME,
  version: process.env.APP_VERSION,
  author: process.env.APP_AUTHOR,
})

angular.element(() => angular.bootstrap(document, [
  app,
  deprecated,
  inicio,
  kendu,
], {strictDi: true}))



// WEBPACK FOOTER //
// ./src/index.js